import { CampaignTypes, ToneTypes } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  fields: {
    title: {
      label: 'Titlu',
      placeholder: 'Introduceți titlul notificării',
    },
    body: {
      label: 'Corpul mesajului',
      placeholder: 'Introduceți mesajul dvs.',
    },
    promo_code: {
      label: 'Cod promoțional',
      placeholder: 'Selectați codul promoțional',
    },
    offers: {
      label: 'Oferte',
      placeholder: 'Selectați oferta',
    },
    campaign_type: {
      label: 'Tip campanie',
      placeholder: 'Selectați tipul campaniei',
    },
    tone: {
      label: 'Ton de voce',
      placeholder: 'Selectați un ton',
    },
  },
  attachment: {
    heading: 'Ce ar trebui să promoveze această campanie?',
    offer: {
      title: 'Ofertă',
      description: 'Alegeți din ofertele dvs. active.',
    },
    promo_code: {
      title: 'Cod promoțional',
      description: 'Alegeți din codurile promoționale active.',
    },
  },
  buttons: {
    generate: 'Generați',
    improve: 'Îmbunătățiți cu AI',
    undo: 'Anulați ({{count}})',
  },
  tone_options: {
    [ToneTypes.Friendly]: 'Prietenos 🙂',
    [ToneTypes.Elegant]: 'Elegant ✨',
    [ToneTypes.Playful]: 'Jucăuș 🎉',
    [ToneTypes.Professional]: 'Profesional 👨‍💼',
    [ToneTypes.Informative]: 'Informativ 📊',
    [ToneTypes.Persuasive]: 'Persuasiv 💪',
  },
  campaign_types: {
    [CampaignTypes.Promotional]: 'Promoțional 🚀',
    [CampaignTypes.Informational]: 'Informațional ℹ️',
  },
  no_promo_codes: {
    title: 'Niciun cod promoțional eligibil',
    description: 'Creați un cod promoțional nou.',
    create_promo_code: 'Creare cod promoțional',
  },
  no_offers: {
    title: 'Nicio ofertă activă',
    description: 'Creați o ofertă nouă.',
    create_offer: 'Creare ofertă',
  },
  feedback: {
    success: 'Generat cu succes',
    error: 'Generare eșuată',
  },
};
